import { Button } from '@/components/ui/button'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { RANKING_IMAGES } from '../constants'
import { TierRow } from './table-tiers.data'

export const TableTiers = () => {
  const t = useTranslations()

  const tableTiersData = [
    {
      rows: [
        {
          title: t(
            'landing_coolclub_page.membership.table.minimum_spend.title'
          ),
          new: ['0 VND'],
          silver: ['500.000 VND'],
          gold: ['2.000.000 VND'],
          platinum: ['5.000.000 VND'],
        },
      ],
      description: {
        title: t(
          'landing_coolclub_page.membership.table.minimum_spend.description'
        ),
        link: {
          title: t(
            'landing_coolclub_page.membership.table.minimum_spend.detail'
          ),
          href: '/page/coolclub-chinh-sach-khach-hang-than-thiet',
        },
      },
    },
    {
      rows: [
        {
          title: t('landing_coolclub_page.membership.table.cashback.normal'),
          new: ['1%'],
          silver: ['3%'],
          gold: ['5%'],
          platinum: ['7%'],
        },
      ],
    },
    {
      rows: [
        {
          title: t(
            'landing_coolclub_page.membership.table.welcome_bonus.title'
          ),
          new: [
            t(
              'landing_coolclub_page.membership.table.welcome_bonus.new.voucher'
            ),
            t(
              'landing_coolclub_page.membership.table.welcome_bonus.new.coolcash'
            ),
          ],
          silver: [
            t('landing_coolclub_page.membership.table.welcome_bonus.silver'),
          ],
          gold: [
            t('landing_coolclub_page.membership.table.welcome_bonus.gold'),
          ],
          platinum: [
            t('landing_coolclub_page.membership.table.welcome_bonus.platinum'),
          ],
        },
        {
          title: t(
            'landing_coolclub_page.membership.table.quarterly_bonus.title'
          ),
          new: [
            t('landing_coolclub_page.membership.table.quarterly_bonus.new'),
          ],
          silver: [
            t('landing_coolclub_page.membership.table.quarterly_bonus.silver'),
          ],
          gold: [
            t('landing_coolclub_page.membership.table.quarterly_bonus.gold'),
          ],
          platinum: [
            t(
              'landing_coolclub_page.membership.table.quarterly_bonus.platinum'
            ),
          ],
        },
      ],
    },
    {
      rows: [
        {
          title: t('landing_coolclub_page.membership.table.birthday_gift'),
          ticks: {
            new: false,
            silver: true,
            gold: true,
            platinum: true,
          },
        },
        // {
        //   title: t('landing_coolclub_page.membership.table.special_gift'),
        //   ticks: {
        //     new: false,
        //     silver: false,
        //     gold: false,
        //     platinum: true,
        //   },
        // },
      ],
    },
    {
      rows: [
        {
          title: t('landing_coolclub_page.membership.table.greeting_card'),
          ticks: {
            new: true,
            silver: true,
            gold: true,
            platinum: true,
          },
        },
        // {
        //   title: t('landing_coolclub_page.membership.table.product_trial'),
        //   ticks: {
        //     new: false,
        //     silver: false,
        //     gold: false,
        //     platinum: true,
        //   },
        // },
      ],
    },
  ]

  return (
    <div className='mx-auto max-w-[1300px] rounded-3xl bg-[#F4F4FF80] px-12 py-13'>
      <div className='grid grid-cols-6'>
        <div className='col-span-2'></div>

        {Object.values(RANKING_IMAGES).map((image) => (
          <div key={image} className='flex justify-center'>
            <Image
              width={200}
              height={24}
              className='h-6 w-auto'
              src={ImageHelper.getImageUrl(t(image))}
              alt='Ranking'
            />
          </div>
        ))}
      </div>

      <div className='mt-5 space-y-12'>
        {tableTiersData.map((section, idx) => (
          <div key={idx}>
            <div className='space-y-6 rounded-2xl border-2 border-primary-100 bg-light/60 px-4 py-3 pl-8'>
              {section.rows.map((row, i) => (
                <TierRowComponent key={i} row={row} />
              ))}
            </div>
            {section.description && (
              <div className='!mt-2 flex items-center justify-end text-sm'>
                {section.description.title}
                <Link
                  href={section.description.link.href}
                  className='ml-1 text-primary underline'
                >
                  {section.description.link.title}
                </Link>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className='mt-10 flex items-center justify-center'>
        <Button asChild variant={'outline-neutral'} className='h-10'>
          <Link href='/page/coolclub-chinh-sach-khach-hang-than-thiet'>
            {t('landing_coolclub_page.membership.table.policy_button')}
            <svg
              width='20'
              height='13'
              viewBox='0 0 20 13'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M19.5303 7.03033C19.8232 6.73744 19.8232 6.26256 19.5303 5.96967L14.7574 1.1967C14.4645 0.903804 13.9896 0.903805 13.6967 1.1967C13.4038 1.48959 13.4038 1.96446 13.6967 2.25736L17.9393 6.5L13.6967 10.7426C13.4038 11.0355 13.4038 11.5104 13.6967 11.8033C13.9896 12.0962 14.4645 12.0962 14.7574 11.8033L19.5303 7.03033ZM6.55671e-08 7.25L19 7.25L19 5.75L-6.55671e-08 5.75L6.55671e-08 7.25Z'
                fill='currentColor'
              />
            </svg>
          </Link>
        </Button>
      </div>
    </div>
  )
}

const tierCellClass: Record<'new' | 'silver' | 'gold' | 'platinum', string> = {
  new: ' border-r-[3px] border-r-primary bg-primary/20  text-neutral-900',
  silver:
    ' border-r-[3px] border-r-neutral-900/50 bg-neutral-600/20  text-neutral-900',
  gold: ' border-r-[3px] border-r-[#FF9F0F] bg-[#FFF38AB2]  text-neutral-900',
  platinum: ' bg-neutral-900  text-light',
}

const TierCell = ({
  value,
  tick,
  tier,
  className,
}: {
  value?: string[]
  tick?: boolean
  tier: 'new' | 'silver' | 'gold' | 'platinum'
  className?: string
}) => (
  <div
    className={cn(
      'flex h-17 flex-col items-center justify-center rounded-lg text-base leading-4.5',
      tierCellClass[tier],
      className
    )}
  >
    {tick ? (
      <Image
        src={
          tier === 'platinum'
            ? '/icons/coolclub/tick-silver.svg'
            : '/icons/coolclub/tick-blue.svg'
        }
        alt='Tick'
        width={56}
        height={56}
        className={
          tier === 'platinum'
            ? 'h-14 w-14 object-cover brightness-100'
            : 'h-14 w-14 object-cover'
        }
      />
    ) : (
      value?.map((item) => (
        <p
          key={item}
          className='mb-2 whitespace-pre-wrap border-b border-b-neutral-200 pb-2 last-of-type:mb-0 last-of-type:border-none last-of-type:pb-0'
        >
          {item}
        </p>
      ))
    )}
  </div>
)

const TierRowComponent = ({ row }: { row: TierRow }) => {
  const hasValue = ['new', 'silver', 'gold', 'platinum'].some((tier) => {
    const value = row[tier as keyof TierRow]
    return Array.isArray(value) && value.length > 1
  })

  return (
    <div className='grid grid-cols-6'>
      <div className='col-span-2 mr-6 flex items-center whitespace-pre-wrap py-4 font-sans text-lg font-medium leading-6 text-neutral-900'>
        {row.title}
      </div>
      <TierCell
        value={row.new}
        tick={row.ticks?.new}
        tier='new'
        className={hasValue ? 'h-auto py-3' : ''}
      />
      <TierCell
        value={row.silver}
        tick={row.ticks?.silver}
        tier='silver'
        className={hasValue ? 'h-auto py-3' : ''}
      />
      <TierCell
        value={row.gold}
        tick={row.ticks?.gold}
        tier='gold'
        className={hasValue ? 'h-auto py-3' : ''}
      />
      <TierCell
        value={row.platinum}
        tick={row.ticks?.platinum}
        tier='platinum'
        className={hasValue ? 'h-auto py-3' : ''}
      />
    </div>
  )
}
